import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CTASection } from '../components/CTASection';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;
      (fbq as any).callMethod.apply(fbq, args);
    } else {
      ;
      (fbq as any).queue.push(args);
    }
  } as any;
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
  window.fbq('init', '745391951987319');
  window.fbq('track', 'PageView');
}
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  const handleAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        value: 6.36,
        currency: 'USD',
        content_name: 'The Cortisol Reset Kitchen',
        content_type: 'product'
      });
    }
    window.location.href = 'https://buenavibrax.com/cart/45502602674233:1';
  };
  return <main className="w-full min-h-screen bg-cream font-sans" data-id="element-545">
      <HeroSection data-id="element-546" />
      <ProblemSection data-id="element-547" />
      <MechanismSection data-id="element-548" />
      <ProductSection data-id="element-549" />
      <BonusSection data-id="element-550" />
      <TestimonialsSection data-id="element-551" />
      <OfferSection onAddToCart={handleAddToCart} data-id="element-552" />
      <GuaranteeSection data-id="element-553" />
      <CTASection onAddToCart={handleAddToCart} data-id="element-554" />
    </main>;
}